import React from 'react';
import { colors } from '../../constants/colors';
import { countryFlagEmoji } from '../../utils/webAnalyticsGeo';

const formatNumber = (value) => (Number(value) || 0).toLocaleString();

const CountriesDetailsModal = ({
  open,
  onClose,
  details,
  loading,
  error,
  days,
}) => {
  if (!open) return null;

  const breakdown = details?.breakdown || [];
  const maxCount = Math.max(...breakdown.map((r) => r.count || 0), 1);

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 3000,
        backgroundColor: 'rgba(15, 23, 42, 0.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: 'min(720px, 100%)',
          maxHeight: '90vh',
          overflow: 'auto',
          backgroundColor: colors.background.primary,
          borderRadius: '12px',
          boxShadow: '0 20px 50px rgba(15, 23, 42, 0.2)',
          padding: '24px',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: '16px',
            marginBottom: '20px',
          }}
        >
          <div>
            <h2
              style={{
                margin: 0,
                fontSize: '20px',
                fontWeight: 700,
                color: colors.text.primary,
              }}
            >
              {countryFlagEmoji(details?.countryCode)}{' '}
              {details?.country || 'Country details'}
            </h2>
            <p
              style={{
                margin: '6px 0 0',
                fontSize: '12px',
                color: colors.text.light,
              }}
            >
              Last {days} days · {formatNumber(details?.visitors)} visitors ·{' '}
              {formatNumber(details?.events)} events
              {details?.percentage != null ? ` · ${details.percentage}%` : ''}
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            style={{
              border: `1px solid ${colors.borderVariants.light}`,
              background: colors.background.secondary,
              borderRadius: '8px',
              padding: '8px 12px',
              cursor: 'pointer',
              fontWeight: 600,
              color: colors.text.primary,
              height: 'fit-content',
            }}
          >
            Close
          </button>
        </div>

        {error && (
          <div
            style={{
              padding: '12px 14px',
              marginBottom: '16px',
              borderRadius: '8px',
              backgroundColor: '#fef2f2',
              color: colors.status.error,
              fontSize: '14px',
            }}
          >
            {error}
          </div>
        )}

        {loading && !details ? (
          <div
            style={{
              padding: '48px',
              textAlign: 'center',
              color: colors.text.secondary,
            }}
          >
            Loading country details…
          </div>
        ) : breakdown.length === 0 ? (
          <div
            style={{
              padding: '40px 16px',
              textAlign: 'center',
              color: colors.text.secondary,
            }}
          >
            No activity for this country in the selected period.
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {breakdown.map((row, index) => {
              const widthPct = Math.max(
                8,
                Math.round(((row.count || 0) / maxCount) * 100)
              );
              return (
                <div key={`${row.path}-${row.event}-${index}`}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: 8,
                      marginBottom: 4,
                      fontSize: 13,
                    }}
                  >
                    <span style={{ fontWeight: 600 }}>
                      {row.path || '/'} · {row.event}
                    </span>
                    <span style={{ color: colors.text.secondary }}>
                      {formatNumber(row.count)}
                    </span>
                  </div>
                  <div
                    style={{
                      height: 5,
                      borderRadius: 999,
                      backgroundColor: colors.background.tertiary,
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      style={{
                        width: `${widthPct}%`,
                        height: '100%',
                        backgroundColor: colors.primary,
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default CountriesDetailsModal;
